import { lazy } from 'react';
const QuizConsumption = lazy(() => {
    return import(/* webpackChunkName: "quizConsumption" */ './components').then(({ QuizConsumption }) => ({
        default: QuizConsumption,
    }));
});
export default QuizConsumption;
